import { ref as E } from "vue";
import { getTranslation as u } from "@owc/aem-translations-util";
import { subscribe as _ } from "@seamless/one-context";
const f = {
  separator: "-",
  id: "35e68f8b5769ffbe51d5e3e245f7498f"
}, m = {
  separator: "-",
  id: "256327257efa0b223e1fa85ba6b0cbf7"
}, p = {
  separator: "_",
  id: "42b5f1b854ae37cc8b351c232bf6cb79"
}, P = "SCCS_MBTI-DISCO-AIR", $ = ["Mercedes-AMG", "MERCEDES_AMG"], g = Symbol.for("componentId"), v = "Mercedes-Benz";
async function A(n) {
  return new Promise((r) => {
    _("PageConnection", {
      tenant: "sccs",
      componentName: "air-tnt",
      callback: (c) => {
        r(`${c.pageEnvironmentVariables.language}${n}${c.pageEnvironmentVariables.country}`);
      }
    });
  });
}
async function M() {
  return new Promise((n) => {
    _("PageConnection", {
      tenant: "sccs",
      componentName: "air-tnt",
      callback: (r) => {
        n(r.pageEnvironmentVariables.country);
      }
    });
  });
}
const T = async (n) => await A(n), S = async () => await M(), d = E({}), b = E({}), w = E({});
function R() {
  async function n() {
    const a = async (t) => {
      let e = await T(t);
      return e === `de${t}AQ` && (e = `de${t}DE`), e === `en${t}AQ` && (e = `en${t}AU`), e;
    };
    try {
      d.value = await u(
        await a(p.separator),
        p.id,
        "i18next"
      );
    } catch {
      throw new Error(
        `CMN_I18N_CMP: Failed to fetch compare translations for market ${await a(p.separator)}`
      );
    }
    try {
      b.value = await u(
        await a(f.separator),
        f.id,
        "i18next"
      );
    } catch {
      throw new Error(
        `CMN_I18N_DCP: Failed to fetch DCP translations for market ${await a(f.separator)}`
      );
    }
    try {
      w.value = await u(
        await a(m.separator),
        m.id,
        "i18next"
      );
    } catch {
      throw new Error(
        `CMN_I18N_OT: Failed to fetch OneTeaser translations for market ${await a(m.separator)}`
      );
    }
  }
  function r(a) {
    return !!o(a, d.value) || !!o(a, b.value);
  }
  function c(a, t) {
    if (!a)
      return "";
    const e = o(a, d.value) || o(a, b.value) || o(a, w.value) || a;
    return C(e, t);
  }
  function o(a, t) {
    return a.split(".").reduce((e, l) => {
      if (e)
        return e[l];
    }, t);
  }
  function C(a, t) {
    if (!t)
      return a;
    let e = a;
    return Object.entries(t).forEach((l) => {
      const [s, i] = l;
      e = e.replace(`{{${s}}}`, i), e = e.replace(`{{ ${s} }}`, i), e = e.replace(`{${s}}`, i), e = e.replace(`{ ${s} }`, i);
    }), e;
  }
  return { loadTranslations: n, t: c, existsWithoutFallback: r };
}
export {
  g as C,
  $ as D,
  f as P,
  S as a,
  m as b,
  p as c,
  v as d,
  T as l,
  P as m,
  R as u
};
//# sourceMappingURL=i18n-Cc8soYM3.js.map
